import browse from './browse.json'

export default { browse }
